import { t } from 'i18next';

const AnalysisFalsificationGridPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: t("sidePanel.accounting.submenu.analysisFalsification"),
        mnemocode: 'analysis_falsification_plugin',
        permission: 'Lot',
        columns: [
            {
                order: index++,
                propertyName: 'goodsName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.goodsName'),
                visibility: true,
                width: 300
            }, {
                order: index++,
                propertyName: 'producerName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.producerName'),
                visibility: true,
                width: 300
            }, {
                order: index++,
                propertyName: 'seriesNumber',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.seriesNumber'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'quantityAdd',
                propertyType: 'number',
                displayName: t('documents.actRejection.fields.quantityAdd'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'quantitySub',
                propertyType: 'number',
                displayName: t('documents.actRejection.fields.quantitySub'),
                visibility: false,
                width: 150
            }, {
                order: index++,
                propertyName: 'quantityRem',
                propertyType: 'number',
                displayName: t('documents.actRejection.fields.quantityRem'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'quantityRes',
                propertyType: 'number',
                displayName: t('documents.actRejection.fields.quantityRes'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'quantityTotal',
                propertyType: 'number',
                displayName: t('documents.actRejection.fields.quantityTotal'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'supplier',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.supplierName'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'invoiceNum',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.invoiceNum'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'falsificatDocNum',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.falsificatDocNum'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'falsificatDocDate',
                propertyType: 'datetime',
                displayName: t('documents.actRejection.fields.falsificatDocDate'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'falsificatReasons',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.falsificatReasons'),
                visibility: true,
                width: 150
            }, {
                order: index++,
                propertyName: 'falsificatLabName',
                propertyType: 'string',
                displayName: t('documents.actRejection.fields.falsificatLabName'),
                visibility: true,
                width: 300
            }
        ]
    }
}
export default AnalysisFalsificationGridPluginSettings